import { Col, Row } from "antd";
import { UNITS } from "../../Common/Constants";

const ParameterCardLayout = ({
  header,
  unit,
  belowRange,
  aboveRange,
  minValue,
  maxValue,
}) => {
  return (
    <div className="section-card">
      <Row>
        <Col span={24} className="text-center mt1">
          <div className="flex-center">
            <span className="section-head">{header}</span>
            <span className="mt025 unit ml025">{unit}</span>
          </div>
        </Col>
      </Row>

      <Row gutter={[16, 16]} justify="space-around" className="mt05 pd1">
        <Col xs={16} sm={10} md={10} className="range-box">
          <div className="text-center">
            <div className="range-box-head grey below-text">Below Range</div>
            <div className="range-box-value mt05">
              {belowRange}
              {UNITS.PERCENT}
            </div>
          </div>
        </Col>
        <Col xs={16} sm={10} md={10} className="range-box">
          <div className="text-center">
            <div className="range-box-head grey">Above Range</div>
            <div className="range-box-value mt05">
              {aboveRange}
              {UNITS.PERCENT}
            </div>
          </div>
        </Col>
      </Row>

      <Row className="range-footer mt05 text-center">
        <Col span={12}>
          <div className="range-box-head grey">Min</div>
          <div className="flex-center">
            <span className="range-footer-value">{minValue}</span>
            <span className="mt025 unit ml025">{unit}</span>
          </div>
        </Col>
        <Col span={12}>
          <div className="range-box-head grey">Max</div>
          <div className="flex-center">
            <span className="range-footer-value">{maxValue}</span>
            <span className="mt025 unit ml025">{unit}</span>
          </div>
        </Col>
      </Row>
    </div>
  );
};

export default ParameterCardLayout;
